import React from 'react';

import { IFullwidthHero20Fields } from '../../../types/contentful';

import MobileView from './Viewports/MobileView';
import DesktopView from './Viewports/DesktopView';

export function FullwidthHero(props: IFullwidthHero20Fields) {
  return (
    <>
      <MobileView {...props} />
      <DesktopView {...props} />
    </>
  );
}
